import { WorkCenterDto } from '@app/generated/model';

export class WorkCenter {
  id: string;
  number: string;
  name: string;
  site: string;
  selected?: boolean;

  static fromDto(dto: WorkCenterDto): WorkCenter {
    return {
      id: dto.id,
      number: dto.number,
      name: dto.name,
      site: dto.site,
    };
  }
}
